angular
    .module('quattro.bmbo.email.edit', [
        'quattro.bmbo.email.model',
        'quattro.bmbo.email.form',
        'quattro.core.alert.service',
    ])
    .controller('BmboEmailEditController', function ($routeParams, $location, $window, Email, alertService, $translate) {

        var account = $routeParams.account;
        var domain = $routeParams.domain;
        var email = $routeParams.email || '';

        console.log($translate); 

        var model = new Email({
            mail: email + '@' + domain,
        });
        model.get();

        this.data = model.data;

        this.cancel = function () {
            $window.history.back();
        };

        var is_german = $translate.use() === 'de_DE';

        model.onRejected = function(a) {
            if (a.code === 398) {
                const err = a.data[0];


                var reason = "";
                switch(err.reason) {
                    case "ownDomainAliasses":
                        reason = is_german ? 
                            "Zu viele aliase. Erlaubt: " + err.allowed + " Vorhanden: " + err.used :
                            "To many aliases. Allowed: " + err.allowed + " Present: " + err.used
                        break;
                    default:
                        reason = JSON.stringify(err);

                }
                

                alertService.add(
                    'error', 
                    is_german ?     'Downgrade nicht möglich: ' + reason + "." :
                                    'Downgrade not possible: ' + reason + "."
                );


            }
            else {
                alertService.add('error', 'Email ' + email + ' konnte nicht vollständig gespeichert werden.');
            }
        }

        this.save = function () {
            model.update().then(function () {
                $location.path('/account=' + account + '/domain=' + domain + '/email=' + email);
            });
        };
    });
